import CryptoJS from 'crypto-js';
import { User } from '../store.js';

 const apiURL = window.location.hostname == "calendar.airbetter.com"
 ? "https://sails.airbetter.com:1337/"
 : window.location.hostname.split(".")[1] == "netlify"
 ? "https://sails.airbetter.com:1337/"
 : window.location.hostname == "localhost"
 ? "http://localhost:1337/"
 : 0;

const fetchNode = async (node, params = {}, isJson=true) => {
	const url = new URL(apiURL + node);
	let user;
	const unUser = User.subscribe(v => user = v);

	Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
	const headers = getAuthHeaders(user,url.searchParams.toString());
	const res = await fetch(url,{headers});
	return isJson ? res.json():res.arrayBuffer();
}

const getAuthHeaders = (user,query) => {
	if(user && user.token && user.id){
		const timeStamp = Date.now();
		//console.log(query);
		const token = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(query+timeStamp,user.token));
		return {
			token,
			timeStamp,
			user : user.id
		};
	}
}

export default fetchNode;